import { NgModule } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { LayoutEmptyComponent } from '../common/components/layout-empty/layout-empty.component';
import { LayoutDefaultComponent } from '../common/components/layout-default/layout-default.component';
import { UserAuthGuard } from '../user/guards/user-auth-guard'

@NgModule({
  declarations: [],
  imports: [
  ],
  providers: [
    provideRouter([
      {
        path: 'mobile-consent',
        component: LayoutEmptyComponent,
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/consent/consent.component').then((x) => x.ConsentComponent),
          }
        ]
      }
    ])
  ]
})
export class StaticContentRoutingModule { }
